import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";
import { SESSION_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { post } from "../../services/smartApiService";

interface Props {
  loadTableData: () => void;
  dataIn: any;
}

const schema = Yup.object({
  ename: Yup.string().required("Name is required"),
  euserid: Yup.string()
    .matches(/^\S*$/, "Loco Pilot ID cannot contain spaces")
    .required("Loco Pilot ID is required"),
  reporting_place: Yup.string(),
  designation: Yup.string(),
});

const SessionUserEditForm: React.FC<Props> = ({ loadTableData, dataIn }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      ename: dataIn?.ename || "",
      euserid: dataIn?.euserid || "",
      reporting_place: dataIn?.reporting_place || "",
      designation: dataIn?.designation || "",
    },
  });

  const { closeModal } = useSiteContext();

  const onSubmit = (data: any) => {
    const payload = {
      session_user_id: dataIn?.ID,
      ename: data.ename,
      euserid: data.euserid,
      reporting_place:data.reporting_place,
      designation:data.designation
    };
    const subscription = post(SESSION_URLS.UPDATE_SESSION_USER, payload).subscribe(() => {
      loadTableData();
      closeModal();
    });
    return () => subscription.unsubscribe();
  };

  const elements: SdsFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: 6,
      name: "ename",
      element: {
        label: "Loco Pilot Name",
        isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "TEXT_BOX",
      width: 6,
      name: "euserid",
      element: {
        label: "Loco Pilot ID",
        isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },

         {
      type: "TEXT_BOX",
      width: 6,
      name: "reporting_place",
      element: {
        label: "Reporting Place",
        // isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },
        {
      type: "TEXT_BOX",
      width: 6,
      name: "designation",
      element: {
        label: "Designation",
        // isRequired: true,
        inputType: "BORDER_LABEL",
      },
    },

    {
      type: "BUTTON",
      width: 12,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-action-button"],
        label: "Update",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];

  return (
    <div className="sd-hims-input">
      <SdsForm elements={elements} errors={errors} control={control} />
    </div>
  );
};

export default SessionUserEditForm;
